import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import clinicService from '../../../../../services/clinic.service';
import AddressForm from './AddressForm';
import Loading from '../../../../common/Loading';

const AddressCard = () => {
    const { clinicId } = useParams();
    const [isEditing, setIsEditing] = useState(false);
    const [address, setAddress] = useState({
        street: '',
        city: '',
        postalCode: '',
        country: '',
        province: '',
    });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        clinicService
            .getAddress(clinicId)
            .then((res) => {
                setAddress(res.data);
                setIsLoading(false);
            })
            .catch((error) => {
                if (error.response?.status === 404) {
                    setAddress({
                        street: '',
                        city: '',
                        postalCode: '',
                        country: '',
                        province: '',
                    });
                    setIsEditing(true);
                }
                setIsLoading(false);
            });
    }, [clinicId]);

    const updateAddress = (add) => {
        setAddress(add);
    };

    const updateEditing = () => {
        setIsEditing(!isEditing);
    };

    const formattedAddress = [address.street, address.city, address.province, address.postalCode, address.country]
        .filter(Boolean)
        .join(', ');

    return (
        <div className="notifications-panel">
            <div className="notifications-panel__header justify-content-between">
                <span className="d-flex align-items-center gap-2">
                    <i className="bi bi-geo-alt"></i>
                    Address
                </span>
                <button
                    type="button"
                    className={`btn btn-sm ${isEditing ? 'btn-outline-danger' : 'btn-outline-primary'}`}
                    onClick={() => setIsEditing(!isEditing)}
                >
                    <i className={`bi ${isEditing ? 'bi-x' : 'bi-pencil-square'}`}></i>
                    {isEditing ? ' Cancel' : ' Edit'}
                </button>
            </div>
            <div className="notifications-panel__body">
                {isLoading ? (
                    <Loading />
                ) : !isEditing ? (
                    formattedAddress ? (
                        <div className="notifications-info-value">{formattedAddress}</div>
                    ) : (
                        <div className="notifications-empty-state py-3">
                            <i className="bi bi-geo-alt"></i>
                            No address on file.
                        </div>
                    )
                ) : (
                    <AddressForm address={address} updateAddress={updateAddress} updateEditing={updateEditing} />
                )}
            </div>
        </div>
    );
};

export default AddressCard;
